export const canAccessAdminFeatures = (auth) => {
    if (auth?.isAdmin?.()) return true;
    if (!auth?.isSupervising?.()) return false;

    return auth?.getAdminSessionFromLocalStorage?.()?.user?.role === 1;
};
